import * as React from 'react';
import ReactGA from 'react-ga';
import stripHTML from '~/utils/stripHTML';
import config from '~/config';

const ExternalLink = (props) => {
  const openLink = (link) => {
    const target = props.target || '_blank';
    window.open(link, target);

    ReactGA.outboundLink({
      label: stripHTML(props.children)
    },
    () => {
      if (config.debug) { console.log('open link', props.children, props.href, props.target); }
    })
  }

  return <a onClick={() => openLink(props.href)}>{ props.children }</a>;
}

export default ExternalLink;


// WEBPACK FOOTER //
// ./src/components/common/ExternalLink.tsx